import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {OAuthService} from 'angular-oauth2-oidc';
import {environment} from '../../../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {CustomsValidators} from '../../validators/custom.validators';


@Injectable()
export class HomeAllRequestService {

  urlHomeRequest: string;
  urlPeopleAgreement: string;


  constructor(private http: HttpClient, private oauthService: OAuthService) {
    this.urlHomeRequest = `${environment.bffBaseUrl}/pages/home?page=1&limit=5&desc=true`;
    this.urlPeopleAgreement = `${environment.bffBaseUrl}/pages/people-agreement`;
  }


  getHomeRequest() {
    const urlBuilder = this.urlHomeRequest;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getTerms() {
    const urlBuilder = this.urlPeopleAgreement;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  acceptTerms(ID): Observable<any> {
    const urlBuilder = `${this.urlPeopleAgreement}/${ID}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.patch(urlBuilder, {}) : throwError(CustomsValidators.msgNotValidUrl);

  }

}

export interface Request {
  Status: string;
  RequestNumber: number;
  RequestDate: string;
}
